// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"79b6c10d","453":"fb45158c"}[chunkId] + ".chunk.js";
};